import "core-js/modules/web.dom-collections.iterator.js";
import T from 'prop-types';
import { useReducer, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useIsomorphicLayoutEffect } from '../../hooks/useIsomorphicLayoutEffect';
import { jsx as _jsx } from "react/jsx-runtime";

function Portal({
  children
}) {
  const mountNode = useRef(null);
  const portalNode = useRef(null);
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  useIsomorphicLayoutEffect(() => {
    // It's possible that the portal itself has been portaled outside the
    // document, e.g. in another window. Therefore it's important to append to
    // the correct document element.
    const {
      ownerDocument
    } = mountNode.current;
    portalNode.current = ownerDocument.createElement('decibel-portal');
    ownerDocument.body.appendChild(portalNode.current);
    forceUpdate();
    return () => {
      portalNode.current.ownerDocument.body.removeChild(portalNode.current);
    };
  }, []);
  return portalNode.current ? /*#__PURE__*/createPortal(children, portalNode.current) : /*#__PURE__*/_jsx("span", {
    ref: mountNode
  });
}

Portal.propTypes = {
  children: T.node.isRequired
};
export { Portal };